import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import PrimaryButton from '../Components/Common/Button/primary-button.js';
import { PdfPopUpView } from '../Components/Common/Dashboard/pdf-pop-up-view.js';

const AttachedDocuments = ({ documentAttachment }) => {
	const [viewPopup, setViewPopup] = useState(false);
	const [selectedAttachment, setSelectedAttachment] = useState(null);

	useEffect(() => {
		if (selectedAttachment) {
			setViewPopup(true);
		} else {
			setViewPopup(false);
		}
	}, [selectedAttachment]);

	const handleViewClick = (attachment) => {
		setSelectedAttachment(attachment);
	};

	const handleClose = () => {
		setSelectedAttachment(null);
	};

	return (
		<>
			{documentAttachment?.length > 0 && (
				<div>
					<div>Attached Documents</div>
					<div>
						{documentAttachment.map((attachment) => (
							<div
								key={attachment.attachmentId}
								style={{
									display: 'flex',
									alignItems: 'center',
									margin: '10px 0'
								}}
							>
								<div
									style={{
										flex: '1',
										overflow: 'hidden',
										textOverflow: 'ellipsis',
										whiteSpace: 'nowrap',
										fontSize: '14px'
									}}
									title={attachment.attachmentName}
								>
									{attachment.attachmentName}
								</div>
								<PrimaryButton
									value='View'
									onClick={() => handleViewClick(attachment)}
									backgroundColor='#B7D423'
									padding='0'
									textcolor='#000000'
									width='50px'
									height='40px'
									borderRadius='8px'
								/>
							</div>
						))}
					</div>
					{viewPopup && (
						<PdfPopUpView
							forwardToEntityBtnAccept={false}
							forwardToEntityBtn={false}
							open={viewPopup}
							close={handleClose}
							showDetails={false}
							DocUrl={`${selectedAttachment?.attachmentType},${selectedAttachment?.attachmentFile}`}
							docName={selectedAttachment?.attachmentName}
							data={{ stampPaperPdfPath: `${selectedAttachment?.attachmentType},${selectedAttachment?.attachmentFile}`, documentName: selectedAttachment?.attachmentName }}
							isEsignFlow
						/>
					)}
				</div>
			)}
		</>
	);
};

export default AttachedDocuments;

AttachedDocuments.propTypes = {
	documentAttachment: PropTypes.any
};
